module.exports = __webpack_public_path__ + "img/insta5.40a6152b.jpg";